import _ from "lodash";

const lodashTruncate = (data, maxLength) => {
  return _.truncate(data, {
      length: maxLength
  });
};

export default lodashTruncate;